import { render } from "./About.vue?vue&type=template&id=672adcee"
const script = {}
script.render = render

export default script